import { render, staticRenderFns } from "./WanSettings.vue?vue&type=template&id=d4074f7a&scoped=true&"
import script from "./WanSettings.vue?vue&type=script&lang=js&"
export * from "./WanSettings.vue?vue&type=script&lang=js&"
import style0 from "./WanSettings.vue?vue&type=style&index=0&id=d4074f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4074f7a",
  null
  
)

export default component.exports